/* JIKOAII MENO – PDP behaviour. ~1.6 KB, defer, keine Abhängigkeiten.
   Web Components: laufen erst, wenn das HTML da ist -> kein Blocking, kein CLS. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Galerie: Slides (Bild / Video / externes Video), Pfeile, Thumbnails,
     Swipe, Tastatur und Lightbox. Videos starten erst, wenn der Slide
     aktiv und im Viewport ist (IntersectionObserver, preload="none").
  ------------------------------------------------------------------ */
  class MenoGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
      if (!this.slides.length) return;
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
      this.stage = this.querySelector('.jk-stage');
      this.counter = this.querySelector('[data-current]');
      this.index = Math.max(0, this.slides.findIndex(function (s) { return s.classList.contains('is-active'); }));

      var self = this;

      this.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb]');
        if (thumb) { self.go(parseInt(thumb.dataset.index, 10)); return; }
        if (e.target.closest('[data-prev]')) { self.go(self.index - 1); return; }
        if (e.target.closest('[data-next]')) { self.go(self.index + 1); return; }
        if (e.target.closest('.jk-playbtn')) { self.playMedia(self.slides[self.index]); return; }
        if (e.target.closest('[data-zoom]')) { self.openLightbox(); return; }
        // Klick aufs Bild öffnet ebenfalls die Lightbox
        var media = e.target.closest('[data-slide] img');
        if (media && !e.target.closest('[data-ext]')) { self.openLightbox(); }
      });

      /* Pfeiltasten, sobald die Galerie den Fokus hat */
      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { self.go(self.index - 1); }
        else if (e.key === 'ArrowRight') { self.go(self.index + 1); }
      });

      /* Swipe auf Touch-Geräten */
      if (this.stage) {
        var x0 = null, y0 = null;
        this.stage.addEventListener('touchstart', function (e) {
          x0 = e.changedTouches[0].clientX; y0 = e.changedTouches[0].clientY;
        }, { passive: true });
        this.stage.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          var dy = e.changedTouches[0].clientY - y0;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { self.go(self.index + (dx < 0 ? 1 : -1)); }
          x0 = null;
        }, { passive: true });
      }

      /* Video nur abspielen, wenn die Galerie wirklich sichtbar ist. */
      if ('IntersectionObserver' in window) {
        this.inView = false;
        this.io = new IntersectionObserver(function (entries) {
          self.inView = entries[0].isIntersecting;
          self.syncMedia();
        }, { threshold: 0.25 });
        this.io.observe(this);
      } else {
        this.inView = true;
      }

      this.syncMedia();
      this.rotateThumbs();
      var badges0 = this.querySelector('.jk-badges');
      if (badges0) badges0.classList.toggle('is-hidden', this.index !== 0);
      window.addEventListener('resize', function () { self.rotateThumbs(); });

      /* Nachbarn erst laden, wenn der Hauptthread frei ist – der LCP hat Vorrang. */
      this.slides[this.index].dataset.hydrated = '1';
      var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
      idle(function () { self.hydrateAround(self.index); });
    }

    /* Haengt Bildquelle bzw. Video-Poster erst ein, wenn der Slide gebraucht wird.
       Spart beim ersten Rendern alle Medien ausser dem sichtbaren. */
    hydrate(i) {
      var n = this.slides.length;
      var slide = this.slides[(i % n + n) % n];
      if (!slide || slide.dataset.hydrated) return;
      slide.dataset.hydrated = '1';
      slide.querySelectorAll('img[data-src]').forEach(function (img) {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
      var video = slide.querySelector('video[data-poster]');
      if (video) { video.poster = video.dataset.poster; video.removeAttribute('data-poster'); }
    }

    /* Aktueller Slide plus direkte Nachbarn – Blaettern wirkt dadurch sofort. */
    hydrateAround(i) {
      this.hydrate(i);
      if (this.slides.length > 1) { this.hydrate(i + 1); this.hydrate(i - 1); }
    }

    go(i) {
      var n = this.slides.length;
      this.index = (i % n + n) % n;
      this.hydrateAround(this.index);
      this.slides.forEach(function (s, k) {
        var active = k === this.index;
        s.classList.toggle('is-active', active);
        if (active) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
      }, this);
      this.thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === this.index ? 'true' : 'false'); }, this);
      if (this.counter) this.counter.textContent = this.index + 1;
      this.syncMedia();
      this.rotateThumbs();
      /* Badges nur auf dem ersten Medium */
      var badges = this.querySelector('.jk-badges');
      if (badges) badges.classList.toggle('is-hidden', this.index !== 0);
    }

    /* Thumb-Leiste als Endlos-Karussell – nur wenn nicht alle Thumbs hineinpassen:
       das aktive Thumb steht oben (mobil: links), danach die nächsten, nach dem letzten wieder das erste. */
    rotateThumbs() {
      var list = this.querySelector('.jk-thumbs');
      if (!list) return;
      var items = Array.prototype.slice.call(list.children);
      items.forEach(function (li) { li.style.order = ''; });
      var vertical = getComputedStyle(list).flexDirection === 'column';
      var overflow = vertical ? list.scrollHeight > list.clientHeight + 2 : list.scrollWidth > list.clientWidth + 2;
      if (!overflow) return;
      var n = items.length, i = this.index;
      items.forEach(function (li, k) { li.style.order = (k - i + n) % n; });
      list.scrollTo({ top: 0, left: 0 });
    }

    /* Videos starten nie von selbst: Klick auf den Play-Button startet sie mit Ton.
       Beim Slidewechsel oder wenn die Galerie den Viewport verlaesst, wird pausiert. */
    syncMedia() {
      this.slides.forEach(function (s, k) {
        var active = k === this.index && this.inView !== false;
        var video = s.querySelector('[data-video]');
        if (video && !active && !video.paused) video.pause();
        var frame = s.querySelector('[data-ext] iframe');
        if (frame && !active) { frame.parentNode.removeChild(frame); s.classList.remove('is-playing'); }
      }, this);
    }

    /* Alles in der Galerie anhalten – damit beim Oeffnen der Lightbox
       nicht zwei Videos gleichzeitig laufen. */
    stopAll() {
      this.slides.forEach(function (s) {
        var video = s.querySelector('[data-video]');
        if (video && !video.paused) video.pause();
        var frame = s.querySelector('[data-ext] iframe');
        if (frame) { frame.parentNode.removeChild(frame); s.classList.remove('is-playing'); }
      });
    }

    /* Klick auf den Play-Button: Shopify-Video mit Ton + Browser-Controls,
       externes Video als iframe – beides erst jetzt, nicht beim Seitenaufbau. */
    playMedia(slide) {
      if (!slide) return;
      var video = slide.querySelector('[data-video]');
      if (video) {
        slide.classList.add('is-playing');
        video.preload = 'auto';
        video.controls = true;
        video.muted = false;
        video.volume = 1;
        var pr = video.play();
        if (pr && pr.catch) pr.catch(function () {});
        return;
      }
      this.playExternal(slide);
    }

    /* YouTube/Vimeo erst auf Klick laden – kein Third-Party-JS beim Seitenaufbau. */
    playExternal(slide) {
      var box = slide && slide.querySelector('[data-ext]');
      if (!box || box.querySelector('iframe')) return;
      slide.classList.add('is-playing');
      var id = box.dataset.id;
      var src = box.dataset.host === 'vimeo'
        ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1'
        : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      var f = document.createElement('iframe');
      f.src = src;
      f.allow = 'autoplay; encrypted-media; picture-in-picture';
      f.setAttribute('allowfullscreen', '');
      f.title = 'Produktvideo';
      box.appendChild(f);
    }

    /* ---------------- Lightbox ---------------- */
    buildLightbox() {
      var self = this;
      var lb = document.createElement('dialog');
      lb.className = 'jk-lb';
      lb.innerHTML =
        '<div class="jk-lb-stage">' +
          '<p class="jk-lb-count"><span data-lb-current>1</span>/' + this.slides.length + '</p>' +
          '<button type="button" class="jk-lb-close" data-lb-close aria-label="Schließen">&times;</button>' +
          (this.slides.length > 1
            ? '<button type="button" class="jk-nav jk-nav--prev" data-lb-prev aria-label="Vorheriges Bild"></button>' +
              '<button type="button" class="jk-nav jk-nav--next" data-lb-next aria-label="Nächstes Bild"></button>'
            : '') +
          '<div class="jk-lb-media" data-lb-media></div>' +
        '</div>' +
        '<div class="jk-lb-foot" data-lb-foot></div>';
      document.body.appendChild(lb);

      var foot = lb.querySelector('[data-lb-foot]');
      if (this.slides.length > 1) {
        this.slides.forEach(function (s, k) {
          var thumbImg = self.thumbs[k] ? self.thumbs[k].querySelector('img') : s.querySelector('img');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'jk-thumb';
          b.dataset.lbThumb = k;
          b.setAttribute('aria-label', 'Ansicht ' + (k + 1));
          if (thumbImg) b.innerHTML = '<img src="' + thumbImg.getAttribute('src') + '" alt="" loading="lazy" decoding="async">';
          foot.appendChild(b);
        });
      }

      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) { lb.close(); return; }
        if (e.target.closest('[data-lb-prev]')) { self.lbGo(self.lbIndex - 1); return; }
        if (e.target.closest('[data-lb-next]')) { self.lbGo(self.lbIndex + 1); return; }
        var t = e.target.closest('[data-lb-thumb]');
        if (t) { self.lbGo(parseInt(t.dataset.lbThumb, 10)); return; }
        if (e.target === lb || e.target.classList.contains('jk-lb-stage') || e.target.classList.contains('jk-lb-media')) lb.close();
      });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.lbGo(self.lbIndex - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); self.lbGo(self.lbIndex + 1); }
      });
      /* Beim Schließen übernimmt die normale Galerie das zuletzt gezeigte Medium. */
      lb.addEventListener('close', function () {
        document.body.classList.remove('jk-lb-open');
        self.clearLbMedia();
        self.go(self.lbIndex);
        var zoom = self.querySelector('[data-zoom]');
        if (zoom) zoom.focus();
      });

      this.lb = lb;
      return lb;
    }

    clearLbMedia() {
      var box = this.lb && this.lb.querySelector('[data-lb-media]');
      if (!box) return;
      var v = box.querySelector('video');
      if (v) v.pause();
      box.innerHTML = '';
    }

    lbGo(i) {
      var n = this.slides.length;
      this.lbIndex = (i % n + n) % n;
      this.hydrateAround(this.lbIndex);
      var slide = this.slides[this.lbIndex];
      var box = this.lb.querySelector('[data-lb-media]');
      this.clearLbMedia();

      var type = slide.dataset.type;
      if (type === 'video') {
        var src = slide.querySelector('video source');
        var v = document.createElement('video');
        v.controls = true; v.playsInline = true; v.autoplay = true; v.muted = false; v.preload = 'auto';
        v.poster = slide.querySelector('video').poster;
        if (src) v.src = src.src;
        box.appendChild(v);
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      } else if (type === 'external_video') {
        var ext = slide.querySelector('[data-ext]');
        var f = document.createElement('iframe');
        f.src = ext.dataset.host === 'vimeo'
          ? 'https://player.vimeo.com/video/' + ext.dataset.id + '?autoplay=1&dnt=1'
          : 'https://www.youtube-nocookie.com/embed/' + ext.dataset.id + '?autoplay=1&rel=0';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.setAttribute('allowfullscreen', '');
        f.title = 'Produktvideo';
        box.appendChild(f);
      } else {
        var srcImg = slide.querySelector('img');
        var img = document.createElement('img');
        img.src = (srcImg && srcImg.dataset.full) || (srcImg && srcImg.currentSrc) || (srcImg && srcImg.src);
        img.alt = srcImg ? srcImg.alt : '';
        img.decoding = 'async';
        box.appendChild(img);
      }

      var cur = this.lb.querySelector('[data-lb-current]');
      if (cur) cur.textContent = this.lbIndex + 1;
      this.lb.querySelectorAll('[data-lb-thumb]').forEach(function (b, k) {
        b.setAttribute('aria-current', k === this.lbIndex ? 'true' : 'false');
      }, this);
    }

    openLightbox() {
      var lb = this.lb || this.buildLightbox();
      this.stopAll();
      this.lbIndex = this.index;
      this.lbGo(this.index);
      document.body.classList.add('jk-lb-open');
      if (lb.showModal) { lb.showModal(); } else { lb.setAttribute('open', ''); }
      var close = lb.querySelector('[data-lb-close]');
      if (close) close.focus();
    }
  }
  customElements.define('meno-gallery', MenoGallery);

  /* Variantenwahl: Preis, Grundpreis, Verfügbarkeit, CTA und URL aktualisieren – ohne Reload. */
  class MenoVariants extends HTMLElement {
    connectedCallback() {
      var data = this.querySelector('[data-variant-json]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-variant-id]');
      this.addEventListener('change', this.update.bind(this));
    }
    current() {
      var pack = this.querySelector('[name="meno-pack"]:checked');
      var plan = this.querySelector('[name="selling_plan"]:checked');
      var v = this.variants.filter(function (x) { return String(x.id) === (pack && pack.value); })[0];
      return { v: v, plan: plan && plan.value };
    }
    update() {
      var sel = this.current();
      if (!sel.v) return;
      if (this.idInput) this.idInput.value = sel.v.id;
      var plan = sel.plan ? sel.v.plans[sel.plan] : null;
      var price = plan ? plan.price : sel.v.price;
      this.setText('[data-price]', plan ? plan.price_str : sel.v.price_str);
      this.setText('[data-unit]', sel.v.unit);
      this.setText('[data-perday]', plan ? plan.perday : sel.v.perday);
      this.setText('[data-compare]', sel.v.compare_str);
      this.setText('[data-save]', plan ? plan.save : sel.v.save);
      this.setText('[data-sticky-price]', plan ? plan.price_str : sel.v.price_str);
      this.setText('[data-sticky-label]', sel.v.title);
      var cta = this.querySelector('[data-cta]');
      if (cta) {
        cta.disabled = !sel.v.available;
        cta.textContent = sel.v.available ? cta.dataset.label + ' · ' + (plan ? plan.price_str : sel.v.price_str) : 'Ausverkauft';
      }
      document.querySelectorAll('[data-sticky-cta]').forEach(function (b) { b.disabled = !sel.v.available; });
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', sel.v.id);
        history.replaceState({}, '', u.toString());
      }
      /* Automatisches Rabatt-Badge folgt der gewaehlten Variante. */
      var badge = document.querySelector('[data-badge-discount]');
      if (badge) {
        if (sel.v.pct > 0) { badge.hidden = false; badge.textContent = '\u2212' + sel.v.pct + ' %'; }
        else { badge.hidden = true; }
      }
      var gallery = document.querySelector('[data-gallery]');
      if (gallery && gallery.jkpGoMedia && sel.v.media > 0) gallery.jkpGoMedia(sel.v.media);
      this.dispatchEvent(new CustomEvent('meno:variant', { bubbles: true, detail: { id: sel.v.id, price: price } }));
    }
    setText(sel, val) {
      this.querySelectorAll(sel).forEach(function (n) {
        if (val === null || val === undefined || val === '') { n.hidden = true; } else { n.hidden = false; n.textContent = val; }
      });
      document.querySelectorAll('.jk-sticky ' + sel).forEach(function (n) { if (val) n.textContent = val; });
    }
  }
  customElements.define('meno-variants', MenoVariants);

  /* Sticky Buy-Bar – beobachtet den Haupt-Button:
     - darunter gescrollt → volle Leiste (alle Geräte)
     - mobil, Haupt-Button noch unterhalb des Bildschirms → nur schwebender Button */
  var bar = document.querySelector('[data-sticky-bar]');
  var mainCta = document.querySelector('[data-cta]');
  if (bar && mainCta && 'IntersectionObserver' in window) {
    var mobile = window.matchMedia('(max-width: 999px)');
    var last = null;
    var apply = function (entry) {
      if (entry) last = entry;
      if (!last) return;
      var out = !last.isIntersecting;
      var below = out && last.boundingClientRect.top < 0;
      var above = out && last.boundingClientRect.top > 0 && mobile.matches;
      bar.setAttribute('data-visible', below || above ? 'true' : 'false');
      bar.setAttribute('data-floating', above ? 'true' : 'false');
    };
    new IntersectionObserver(function (entries) { apply(entries[0]); }).observe(mainCta);
    if (mobile.addEventListener) mobile.addEventListener('change', function () { apply(); });
  }

  /* Sticky-CTA reicht den Klick an das echte Produktformular weiter. */
  document.querySelectorAll('[data-sticky-cta]').forEach(function (b) {
    b.addEventListener('click', function () {
      var form = document.querySelector('[data-product-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  /* Nur ein FAQ-Panel gleichzeitig offen – spart Scrollweg auf Mobile. */
  var faqs = document.querySelectorAll('[data-faq] details');
  faqs.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      faqs.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });
})();
